import { z } from "zod";

export const updatePrestationPriceSchema = z.object({
  name: z.string().min(1),
  exclTaxesPrice: z.coerce.number().nullable(),
  inclTaxesPrice: z.coerce.number().nullable(),
  VAT: z.coerce.number(),
  data: z
    .object({
      days: z.coerce.number().optional(),
    })
    .nullable(),
});

export const defaultUpdatePrestationPriceValues: UpdatePrestationPriceForm = {
  name: "",
  exclTaxesPrice: 0,
  inclTaxesPrice: 0,
  VAT: 0,
  data: null,
};

export type UpdatePrestationPriceForm = z.infer<
  typeof updatePrestationPriceSchema
>;

export const dirtyUpdatePrestationPriceSchema =
  updatePrestationPriceSchema.extend({
    data: z
      .object({
        days: z.coerce
          .number()
          .nullable()
          .optional()
          .transform((val) => (val === null ? 1 : val)),
      })
      .nullable(),
  });

export type DirtyUpdatePrestationPriceForm = z.infer<
  typeof dirtyUpdatePrestationPriceSchema
>;
